"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSeriesTimeSlots = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const types_1 = require("../types");
const validation_1 = require("../validation");
const converter_1 = require("../converter");
const calculator_1 = require("../calculator");
const constants_1 = require("../types/constants");
const INVALID_REPEAT_EVERY_ERROR_MSG = 'The series repeat must have a value of 1 or more';
/**
 * Calculate slotsDate array with slots that repeats daily.
 * @param series {ITimeSlotSeries} - The series to generate the slots for.
 * @param useRepeatEndDate {boolean} - Whether to repeat until the end date.
 * @returns {ISlotDate[]} - The array of slots.
 */
function findDailyDates(series, useRepeatEndDate = true) {
    var _a;
    const slotsDate = [];
    // calculate the difference between the start and end date
    const diff = getDiff(series.startDate, series.endDate, types_1.TimeUnit.DAY);
    const isSame = (0, validation_1.isSameDate)(series.startDate, series.endDate);
    const startDate = (0, dayjs_1.default)(series.startDate);
    let nextDate = startDate.clone();
    if (!series.repeatEvery || series.repeatEvery <= 0) {
        throw new types_1.CustomError(types_1.errorCode.invalidRepeatEvery, INVALID_REPEAT_EVERY_ERROR_MSG);
    }
    if (series.repeatEndDate && useRepeatEndDate) {
        const repeatEndDate = (0, dayjs_1.default)(series.repeatEndDate);
        nextDate = (0, dayjs_1.default)(series.startDate);
        while (!(0, validation_1.isLater)(nextDate, repeatEndDate)) {
            slotsDate.push({
                startDate: nextDate.format(types_1.DateTimeFormats.YYYY_MM_DD),
                // adding the difference to the next end date
                endDate: nextDate.add(diff, types_1.TimeUnit.DAY).format(types_1.DateTimeFormats.YYYY_MM_DD),
            });
            nextDate = nextDate.add(series.repeatEvery, types_1.TimeUnit.DAY);
        }
        return slotsDate;
    }
    const numberOfOccurrences = (_a = series.numberOccurrences) !== null && _a !== void 0 ? _a : 0;
    for (let i = 0; i < numberOfOccurrences; i++) {
        if (slotsDate.length >= numberOfOccurrences) {
            break;
        }
        // If the difference is of a day or more, add the diff to the end date,
        const endDate = isSame ? nextDate : (0, dayjs_1.default)((0, calculator_1.addToDateDays)(nextDate, diff));
        slotsDate.push({
            startDate: nextDate.format(types_1.DateTimeFormats.YYYY_MM_DD),
            endDate: endDate.format(types_1.DateTimeFormats.YYYY_MM_DD),
        });
        nextDate = nextDate.add(series.repeatEvery, types_1.TimeUnit.DAY);
    }
    return slotsDate;
}
/**
 * Calculate slotsDate array with slots that repeats yearly.
 * @param series {ITimeSlotSeries} - The series to generate the slots for.
 * @param useRepeatEndDate {boolean} - Whether to repeat until the end date.
 * @returns {ISlotDate[]} - The array of slots.
 */
// function findYearlyDates(series: ITimeSlotSeries, useRepeatEndDate = true): ISlotDate[] {
// 	const slotsDate: ISlotDate[] = [];
// 	const startDate: dayjs.Dayjs = dayjs(series.startDate);
// 	const dayOfMonth: number = startDate.date();
// 	let currentYear: dayjs.Dayjs = structuredClone(startDate).startOf(TimeUnit.YEAR);
// 	if (!series.repeatEvery || series.repeatEvery <= 0) {
// 		throw new CustomError(errorCode.invalidRepeatEvery, INVALID_REPEAT_EVERY_ERROR_MSG);
// 	}
// 	if (series.repeatEndDate && useRepeatEndDate) {
// 		const repeatEndDate: dayjs.Dayjs = dayjs(series.repeatEndDate);
// 		while (!isLater(currentYear, repeatEndDate)) {
// 			let nextDate: dayjs.Dayjs | null = null;
// 			for (const month of series.repeatOn) {
// 				nextDate = currentYear.clone().month(month).set('date', dayOfMonth);
// 				if (isBetweenStartAndEndDates(nextDate, startDate, repeatEndDate)) {
// 					slotsDate.push({
// 						startDate: formatDateTime(nextDate, DateTimeFormats.YYYY_MM_DD),
// 						endDate: formatDateTime(nextDate, DateTimeFormats.YYYY_MM_DD),
// 					});
// 				}
// 			}
// 			currentYear = currentYear.add(series.repeatEvery, TimeUnit.YEAR);
// 		}
// 		return slotsDate;
// 	}
// 	const numberOfOccurrences: number = (series.numberOccurrences ?? 0) * (series?.repeatOn?.length ?? 0);
// 	const endDate: dayjs.Dayjs = startDate.add(
// 		(series.numberOccurrences ?? 0) * (series.repeatEvery ?? 1),
// 		TimeUnit.YEAR
// 	);
// 	for (let i = 0; i < numberOfOccurrences; i++) {
// 		if (slotsDate?.length >= numberOfOccurrences) {
// 			break;
// 		}
// 		const slots: ISlotDate[] = calculateSlotDatesRepeatSchedule(
// 			currentYear,
// 			startDate,
// 			endDate,
// 			TimeUnit.MONTH,
// 			series.repeatOn,
// 			dayOfMonth
// 		);
// 		slotsDate.push(...slots);
// 		currentYear = currentYear.add(series.repeatEvery, TimeUnit.YEAR);
// 	}
// 	return slotsDate;
// }
// /**
//  * Calculate slotsDate array with slots that repeats monthly.
//  * @param series {SeriesEntity} - The series to generate the slots for.
//  * @param useRepeatEndDate {boolean} - Whether to repeat until the end date.
//  * @returns {ISlotDate[]} - The array of slots.
//  */
// function findMonthlyDates(series: ITimeSlotSeries, useRepeatEndDate = true): ISlotDate[] {
// 	const slotsDate: ISlotDate[] = [];
// 	const startDate: dayjs.Dayjs = dayjs(series.startDate);
// 	let currentMonth: dayjs.Dayjs = startDate.startOf(TimeUnit.MONTH);
// 	if (!series.repeatEvery || series.repeatEvery <= 0) {
// 		throw new CustomError(errorCode.invalidRepeatEvery, INVALID_REPEAT_EVERY_ERROR_MSG);
// 	}
// 	if (series.repeatEndDate && useRepeatEndDate) {
// 		const repeatEndDate: dayjs.Dayjs = dayjs(series.repeatEndDate);
// 		while (!isLater(currentMonth, repeatEndDate)) {
// 			const slots: ISlotDate[] = calculateSlotDatesRepeatSchedule(
// 				currentMonth,
// 				startDate,
// 				repeatEndDate,
// 				'date',
// 				series.repeatOn
// 			);
// 			slotsDate.push(...slots);
// 			currentMonth = currentMonth.add(series.repeatEvery, TimeUnit.MONTH);
// 		}
// 		return slotsDate;
// 	}
// 	const numberOfOccurrences: number = (series.numberOccurrences ?? 0) * (series?.repeatOn?.length ?? 0);
// 	const endDate: dayjs.Dayjs = startDate.add(
// 		(series.numberOccurrences ?? 0) * (series.repeatEvery ?? 1),
// 		TimeUnit.MONTH
// 	);
// 	for (let i = 0; i < numberOfOccurrences; i++) {
// 		if (slotsDate?.length >= numberOfOccurrences) {
// 			break;
// 		}
// 		const slots: ISlotDate[] = calculateSlotDatesRepeatSchedule(
// 			currentMonth,
// 			startDate,
// 			endDate,
// 			'date',
// 			series.repeatOn
// 		);
// 		slotsDate.push(...slots);
// 		currentMonth = currentMonth.add(series.repeatEvery, TimeUnit.MONTH);
// 	}
// 	return slotsDate;
// }
/**
 * Calculate slotsDate array with slots that repeats weekly.
 * @param series {ITimeSlotSeries} - The series to generate the slots for.
 * @param useRepeatEndDate {boolean} - Whether to repeat until the end date.
 * @returns {ISlotDate[]} - The array of slots.
 */
function findWeeklyDates(series, useRepeatEndDate = true) {
    var _a, _b, _c, _d, _e, _f;
    const slotsDate = [];
    const isSame = (0, validation_1.isSameDate)(series.startDate, series.endDate);
    // calculate the difference between the start and end date
    const diff = getDiff(series.startDate, series.endDate, types_1.TimeUnit.DAY);
    const startDate = (0, dayjs_1.default)(series.startDate);
    let currentWeek = startDate.clone();
    if (!series.repeatEvery || series.repeatEvery <= 0) {
        throw new types_1.CustomError(types_1.errorCode.invalidRepeatEvery, INVALID_REPEAT_EVERY_ERROR_MSG);
    }
    if (series.repeatEndDate && useRepeatEndDate) {
        const repeatEndDate = (0, dayjs_1.default)(series.repeatEndDate);
        currentWeek = (0, dayjs_1.default)(series.startDate);
        while (!(0, validation_1.isLater)(currentWeek, repeatEndDate)) {
            const slots = calculateSlotDatesRepeatSchedule(currentWeek, startDate, 
            // If the difference is of a day or more, add the diff to the repeat end date,
            // otherwise, add the repeat every to the current week
            !diff ? repeatEndDate : (0, dayjs_1.default)((0, calculator_1.addToDateDays)(repeatEndDate, diff)), types_1.TimeUnit.DAY, series.repeatOn, 
            // Add the diff to the end date of the slot
            diff);
            slotsDate.push(...slots);
            currentWeek = currentWeek.add(series.repeatEvery, types_1.TimeUnit.WEEK);
        }
        return slotsDate;
    }
    let numberOfOccurrences = ((_a = series.numberOccurrences) !== null && _a !== void 0 ? _a : 0) * ((_c = (_b = series === null || series === void 0 ? void 0 : series.repeatOn) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0);
    const endDate = startDate.add(((_d = series.numberOccurrences) !== null && _d !== void 0 ? _d : 0) * ((_e = series.repeatEvery) !== null && _e !== void 0 ? _e : 1), types_1.TimeUnit.WEEK);
    for (let index = 0; index < numberOfOccurrences; index++) {
        if ((slotsDate === null || slotsDate === void 0 ? void 0 : slotsDate.length) >= numberOfOccurrences) {
            break;
        }
        const slots = calculateSlotDatesRepeatSchedule(currentWeek, startDate, 
        // If the difference is of a day or more, add the diff to the end date,
        // otherwise, add the repeat every to the current week
        isSame ? endDate : (0, dayjs_1.default)((0, calculator_1.addToDateDays)(endDate, diff)), types_1.TimeUnit.DAY, series.repeatOn, 
        // Add the diff to the end date of the slot
        diff);
        if (slots.length !== ((_f = series.repeatOn) === null || _f === void 0 ? void 0 : _f.length) && !index) {
            numberOfOccurrences += 1;
        }
        slotsDate.push(...slots);
        currentWeek = currentWeek.add(series.repeatEvery, types_1.TimeUnit.WEEK);
    }
    return slotsDate;
}
/**
 * Calculate the slot dates for a given series based on repetition schedule.
 * @param currentDate {dayjs.Dayjs} - The current date to add the slots to.
 * @param startDate {dayjs.Dayjs} - The start date of the series.
 * @param endDate {dayjs.Dayjs} - The end date of the series.
 * @param unit {dayjs.UnitType} - The unit to set the date to (day/date)
 * @param repeatSchedule {number[]} - The days of the week to repeat on (1-8).
 * @param [diff=0] {number} - The difference between the start and end date.
 * @param overrideDay {number} - overrides the schedule day.
 */
function calculateSlotDatesRepeatSchedule(currentDate, startDate, endDate, unit, repeatSchedule, diff = 0, overrideDay) {
    const slotsDate = [];
    for (const day of repeatSchedule) {
        const date = currentDate
            .clone()
            // when the day is 8 (BOND Sunday) set the day to 0, which is Sunday of the current week
            .set(unit, (overrideDay !== null && overrideDay !== void 0 ? overrideDay : day === constants_1.BOND_SUNDAY) ? 0 : (0, converter_1.bondDaysToIsoDays)(day));
        // Add the difference to the end date of the slot
        const slotEndDate = date.add(diff, types_1.TimeUnit.DAY).format(types_1.DateTimeFormats.YYYY_MM_DD);
        if ((0, validation_1.isBetweenStartAndEndDates)(slotEndDate, startDate, endDate)) {
            slotsDate.push({
                startDate: date.format(types_1.DateTimeFormats.YYYY_MM_DD),
                endDate: slotEndDate,
            });
        }
    }
    return slotsDate;
}
/**
 * Calculate series slots dates
 * @param series {ITimeSlotSeries} - The series to generate the slots for.
 * @param useRepeatEndDate {boolean} - Whether to repeat until the end date.
 * @returns {ISlotDate[]} - The array of slots.
 */
function buildSeriesTimeSlots(series, useRepeatEndDate = true) {
    if (!series) {
        throw new types_1.CustomError(types_1.errorCode.missingSeriesData, 'The series is missing.');
    }
    if (!(0, validation_1.isValidDate)(series.startDate) || !(0, validation_1.isValidDate)(series.endDate)) {
        throw new types_1.CustomError(types_1.errorCode.invalidDateRange, 'The series start or end date is invalid.');
    }
    switch (series.frequency) {
        case types_1.FrequencyEnum.NONE: {
            const startDate = (0, dayjs_1.default)(series.startDate);
            const endDate = (0, dayjs_1.default)(series.endDate);
            return [
                {
                    startDate: startDate.format(types_1.DateTimeFormats.YYYY_MM_DD),
                    endDate: endDate.format(types_1.DateTimeFormats.YYYY_MM_DD),
                },
            ];
        }
        case types_1.FrequencyEnum.DAILY:
            return findDailyDates(series, useRepeatEndDate);
        case types_1.FrequencyEnum.WEEKLY:
            return findWeeklyDates(series, useRepeatEndDate);
        // case FrequencyEnum.MONTHLY:
        // 	return findMonthlyDates(series, useRepeatEndDate);
        // case FrequencyEnum.YEARLY:
        // 	return findYearlyDates(series, useRepeatEndDate);
        default:
            throw new types_1.CustomError(types_1.errorCode.invalidFrequency, `The frequency type "${series.frequency}" is not supported.`);
    }
}
exports.buildSeriesTimeSlots = buildSeriesTimeSlots;
function getDiff(startDate, endDate, unit) {
    return Math.abs((0, dayjs_1.default)(endDate).diff(startDate, unit));
}
//# sourceMappingURL=time-slots.js.map